import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faPlaneDeparture } from "@fortawesome/free-solid-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

const agencias = [
  {
    nombre: "ALIP Agencia de Viajes y R&B Viajes",
    link: "https://maps.app.goo.gl/Hd1qhpEh3cSori3AA",
    direccion: (
      <>
        Alvear 155.<br />
        3532-470629<br />
        <a href="https://www.instagram.com/alip_viajes/?igsh=MTZqeDh1NGZkMXd0bg" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} style={{ marginRight: 4 }} />
          ALIP Agencia de Viajes y R&B Viajes
        </a>
      </>
    ),
  },
  {
    nombre: "Tierra Soñada Viajes y Turismo",
    link: "https://maps.app.goo.gl/QzvGMfJ4oX4R83U57",
    direccion: (
      <>
        Av. Olmos 577.<br />
        3532-679421
      </>
    ),
  },
  {
    nombre: "Coovaeco Turismo",
    link: "https://maps.app.goo.gl/QzvGMfJ4oX4R83U57",
    direccion: (
      <>
        San Martin 232. Coop la Federación.<br />
        3532-497376
      </>
    ),
  },
];

const AgenciasViajes = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-6">
        <h5>
          <FontAwesomeIcon icon={faPlaneDeparture} style={{ color: "#2980b9", marginRight: 8 }} />
          Agencias de Viajes
        </h5>
        <ul className="lista-referencias">
          {agencias.map((item, i) => (
            <li key={i}>
              <FontAwesomeIcon icon={faMapLocationDot} style={{ color: "#2980b9", marginRight: 8 }} />
              <a href={item.link} target="_blank" rel="noopener noreferrer">
                {item.nombre}
              </a>
              <div className="ms-2 me-auto">{item.direccion}</div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
);

export default AgenciasViajes;